// PATHS
export const ALTA_DOMICILIACION_Y_PAGO_CARTA_PATH = '/cartero-virtual/domiciliaciones/domiciliables/alta';
export const NUMBER_ELEMENTS_PER_PAGE = 50;